import { render, staticRenderFns } from "./supplys.vue?vue&type=template&id=5345ee15&scoped=true"
import script from "./supplys.vue?vue&type=script&lang=js"
export * from "./supplys.vue?vue&type=script&lang=js"
import style0 from "./supplys.vue?vue&type=style&index=0&id=5345ee15&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5345ee15",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins_home/workspace/tax-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5345ee15')) {
      api.createRecord('5345ee15', component.options)
    } else {
      api.reload('5345ee15', component.options)
    }
    module.hot.accept("./supplys.vue?vue&type=template&id=5345ee15&scoped=true", function () {
      api.rerender('5345ee15', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/mdm/views/terminal_audit/form/components/supplys.vue"
export default component.exports